import { render, staticRenderFns } from "./ActivationDialog.vue?vue&type=template&id=5bb04fe1&scoped=true&"
import script from "./ActivationDialog.vue?vue&type=script&lang=js&"
export * from "./ActivationDialog.vue?vue&type=script&lang=js&"
import style0 from "./ActivationDialog.vue?vue&type=style&index=0&id=5bb04fe1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb04fe1",
  null
  
)

export default component.exports